<template>
  <gmap-map style="width: 100%; height: 82vh" :mapTypeId="mapType" :center="center" :options="{ disableDefaultUI: false }"
            :zoom="7">
    <gmap-cluster :zoom-on-click="true">
      <gmap-marker v-for="(point, index) in points"
                   :position="getCoordinates(point)"
                   :clickable="true" :draggable="false"
                   @click="openInfoWindowTemplate(point)"
                   :key="index"
      />
      <gmap-info-window
              :options="{maxWidth: 580}"
              :position="infoWindow.position"
              :opened="infoWindow.open"
              @closeclick="infoWindow.open=false">
        <slot v-if="infoWindow.open" name="info-window" v-bind="infoWindow.item">
          <v-card-title>Info windows title</v-card-title>
          <v-card-text>text</v-card-text>
        </slot>
      </gmap-info-window>
    </gmap-cluster>
  </gmap-map>
</template>

<script>
export default {
  components: { },
  props: {
    points: Array,
    locationKey: {
      type: String,
      default: 'location'
    },
    mapType: {
      type: String, // roadmap | hybrid
      default: 'roadmap'
    }
  },
  computed: {
  },
  name: 'Map',
  data: () => {
    return {
      center: {
        // Геолокація центру україни
        lat: 48.383022,
        lng: 31.1828699
      },
      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        // template: '',
        item: null
      }
    };
  },
  methods: {
    openInfoWindowTemplate (item) {
      this.infoWindow.position = this.getCoordinates(item);
      this.infoWindow.item = item;
      this.infoWindow.open = true;
      this.center = this.infoWindow.position;
      this.$emit('showItem', item);
    },
    getCoordinates (item) {
      const location = this.getLocationObj(item);
      return { lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) };
    },
    getLocationObj (obj) {
      return this.locationKey.split('.').reduce((o, key) => o && o[key] ? o[key] : null, obj);
    }
  }
};
</script>

<style scoped>

</style>
